import { useContext, useState, useEffect } from 'react'
import { PassContext } from "../../pass-context"
import dataSelector from '../data-selector'

const GoogleLogo = () => {

  const { classData, objectData, variables, passType } = useContext(PassContext)

  const [imageSrc, setImageSrc] = useState(null)
  
  let logoUrl = getLogoImage({ classData, objectData, variables, passType })

  useEffect(() => {
    if (!logoUrl) return
    
    const img = new Image()
    img.crossOrigin = "anonymous"          // important for canvas/color picking
    img.onload = () => {
      setImageSrc(logoUrl)
    }
    img.onerror = () => setImageSrc(null)
    img.src = logoUrl                   // set after crossOrigin
  }, [logoUrl])


  return <img src={imageSrc} className="logo" crossOrigin="anonymous" />
}

export default GoogleLogo

const getLogoImage = ({ classData, objectData, variables, passType }) => {
  try {

    switch (passType) {
      case "generic": return dataSelector({ objectData, variables, path: "logo.sourceUri.uri" })
      case "flight": return dataSelector({ objectData:classData, variables, path: "flightHeader.carrier.airlineLogo.sourceUri.uri" })
      // Google allows transit in class data but we are only going to support object data
      case "transit": return dataSelector({ objectData, variables, path: "logo.sourceUri.uri" })
      case "eventTicket": return dataSelector({ objectData:classData, variables, path: "logo.sourceUri.uri" })
      case "giftCard": return dataSelector({ objectData:classData, variables, path: "programLogo.sourceUri.uri" })
      case "loyalty":return dataSelector({ objectData:classData, variables, path: "programLogo.sourceUri.uri" })
      case "offer": return  dataSelector({ objectData:classData, variables, path: "titleImage.sourceUri.uri" })
    }
  }
  catch (err) {
    console.error("Error destructuring logo path")
  }
}